import './set_refuse_reason.css'
import React, { useState } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import CancelIcon from '@mui/icons-material/Cancel';
import SendIcon from '@mui/icons-material/Send';
import Backdrop from '@mui/material/Backdrop';
import Input from "@mui/material/Input";
import { makeStyles } from '@mui/styles';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import swal from 'sweetalert';
import CircularProgress from '@mui/material/CircularProgress';
import { service_change_off_catalogue_state_request, service_change_order_state, service_confirm_with_supplier } from '../../../../../../services/purchase_service';


const useStyles = makeStyles((theme) => ({
  button: { margin: 8, },
  root: {
    '& > *': {
      margin: 8,
    },
    width: '100%',
  },
  input: {
    display: 'none',
  },
  container: {
    maxHeight: 440,
  },
  select: {
    "&:focus": {
      backgroundColor: "white"
    }
  },
  selectInput: {
    "&:hover:not($disabled):not($focused):not($error):before": {
      borderBottomWidth: 0
    },
    "&:after": {
      borderBottomWidth: 0
    }
  }
}));

function Set_refuse_reason({ open_reason_modal, setOpen_reason_modal, details, setDetails, products_bysupplier, setProducts_bysupplier }) {

  const classes = useStyles();
  const selectInputClasses = {
    root: classes.selectInput
  };

  const [errorText, setErrorText] = useState("");
  const [waiting, setWaiting] = useState(false);

  const [reason, setReason] = useState('');

  const [validation_reason, setValidation_reason] = useState("null");


  function submit_refuse_reason() {
    setErrorText("");
    if (reason === '' && validation_reason === "null") {
      setErrorText("Champ vide !");
    } else {
      swal({
        title: "Etes-vous sûr ?",
        text: "!!!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            setWaiting(true);
            let tmp_reason = reason != "" ? reason : validation_reason;
            open_reason_modal.append('refuse_reason', tmp_reason);
            if (open_reason_modal.get('request_state')) {
               service_change_off_catalogue_state_request(open_reason_modal).then((response) => {
               //  console.log("change request state : ",response.data);
                setWaiting(false);
                setReason('');
                setOpen_reason_modal(null);
                let tmp = { ...details };
                tmp.request_state = response.data.request_state;
                tmp.service_refuse_reason = response.data.service_refuse_reason;
                setDetails(tmp);
                swal("Votre réponse a été enregistrée avec succès !", {
                  icon: "success",
                });
              }).catch((error => {
               //  console.log("change request state err : ",error.response);
                setWaiting(false);
              }))
            } else {
              const id_selected_supplier = open_reason_modal.get('id');
              if (open_reason_modal.get('cancel_order')) {
                service_change_order_state(open_reason_modal).then((response) => {
                 //  console.log(response.data);
                  const tmp_order_state = response.data.order_state;
                  setWaiting(false);
                  setReason('');
                  setOpen_reason_modal(null);
                  let tmp_products = { ...products_bysupplier };
                  tmp_products[id_selected_supplier].service_refuse_reason = tmp_reason;
                  tmp_products[id_selected_supplier].order_state = tmp_order_state;
                  setProducts_bysupplier(tmp_products);
                  swal("Votre réponse a été enregistrée avec succès !", {
                    icon: "success",
                  });
                }).catch((error => {
                  ////  console.log(error.response);
                  setWaiting(false);
                }))
                return;
              }
              if (open_reason_modal.get('accord')) {
                service_confirm_with_supplier(open_reason_modal).then((response) => {
                  setOpen_reason_modal(null);
                  const tmp_order_state = response.data.order_state;
                  let tmp_products = { ...products_bysupplier };
                  //tmp_products[order_key].service_accord = true;
                  tmp_products[id_selected_supplier].service_refuse_reason = tmp_reason;
                  tmp_products[id_selected_supplier].order_state = tmp_order_state;
                  setProducts_bysupplier(tmp_products);
                  setWaiting(false);
                  swal("votre réponse a été enregistrée avec succès et le fournisseur sera bientôt notifié !", {
                    icon: "success",
                  });
                }).catch((error) => {
                  //console.log(error.response);
                  setWaiting(false);
                })
              } else {
                service_change_order_state(open_reason_modal).then((response) => {
                  //console.log(response.data);
                  const tmp_order_state = response.data.order_state;
                  setWaiting(false);
                  setReason('');
                  setOpen_reason_modal(null);
                  let tmp_products = { ...products_bysupplier };
                  tmp_products[id_selected_supplier].service_refuse_reason = reason;
                  tmp_products[id_selected_supplier].order_state = tmp_order_state;
                  setProducts_bysupplier(tmp_products);
                  swal("Votre réponse a été enregistrée avec succès !", {
                    icon: "success",
                  });
                }).catch((error => {
                  //console.log(error.response);
                  setWaiting(false);
                }))
              }
            }
          }
        });
    }
  }



  return (
    <Dialog className="set_refuse_raison_container" fullWidth={true} maxWidth={'md'} open={open_reason_modal != null ? true : false} onClose={() => setOpen_reason_modal(null)} aria-labelledby="form-dialog-title" >
      <DialogTitle id="form-dialog-title">Motif</DialogTitle>
      <DialogContent>
        <div>
          {
            errorText === ""
              ? <></>
              : <p className={errorText ? "error" : "valid-champ"}>
                {errorText}
              </p>
          }

          <div style={{ width: "100%", marginTop: "5px" }} >
            {
              open_reason_modal.get('cancel_order')
                ? <> <div className='select_container' >
                  <FormControl style={{ width: '100%', padding: '0 5px' }}>
                    <Select required
                      value={validation_reason}
                      onChange={e => {
                        setValidation_reason(e.target.value)
                      }}
                      input={<Input classes={selectInputClasses} />}
                      inputProps={{ classes: { select: classes.select } }}
                    >
                      <MenuItem value={"null"} disabled>Motif</MenuItem>
                      <MenuItem value="Dépassement du budget">Dépassement du budget</MenuItem>
                      <MenuItem value="Informations incomplètes ou erronées">Informations incomplètes ou erronées</MenuItem>
                      <MenuItem value="Non-conformité aux besoins exprimés">Non-conformité aux besoins exprimés</MenuItem>
                      <MenuItem value="Absence ou non-conformité du devis">Absence ou non-conformité du devis</MenuItem>
                      <MenuItem value="Fournisseur non référencé">Fournisseur non référencé</MenuItem>
                      <MenuItem value="Non-respect des procédures internes">Non-respect des procédures internes</MenuItem>
                      <MenuItem value="Utilité ou justification insuffisante">Utilité ou justification insuffisante</MenuItem>
                      <MenuItem value="Demande effectuée hors délai">Demande effectuée hors délai</MenuItem>
                      <MenuItem value="Risque juridique ou de conformité">Risque juridique ou de conformité</MenuItem>
                      <MenuItem value="Annulation ou modification du projet">Annulation ou modification du projet</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                  <span style={{ display: 'block', margin: '10px' }}>--OU--</span>
                </>
                : <></>
            }
            <TextField
              id="outlined-multiline-flexible"
              label="Motif"
              variant='outlined'
              multiline
              minRows={4}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              style={{ width: "100%" }}
            />
          </div>
        </div>


        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={waiting}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

      </DialogContent>
      <DialogActions>
        <div className='dialogBottom'>
          <div>
            {
              errorText === ""
                ? <></>
                : <p className={errorText ? "col-md-10 error" : "col-md-10 valid-champ"}>
                  {errorText}
                </p>
            }
          </div>
          <div>
            <Button variant="contained" className={waiting ? "submit_but cancel_but disabled_button" : "submit_but cancel_but"} startIcon={<CancelIcon className="my_icon" />} onClick={() => setOpen_reason_modal(null)} >
              Annuler
            </Button>
            <Button variant="contained" className={waiting ? "submit_but valide_but disabled_button" : "submit_but valide_but"} startIcon={<SendIcon className="my_icon" />} onClick={submit_refuse_reason} >
              Envoyer
            </Button>
          </div>
        </div>
      </DialogActions>

    </Dialog>
  )
}

export default Set_refuse_reason
